import { FC, useEffect, useState } from "react";

import {
  CampaignBody,
  CampaignObjectDetectorEnum,
} from "@vviinn/user-managment-client-ts";

import { NamedSelect } from "../../../ui/layout/molecules/NamedSelect";

import { VoidFunc } from "../../../helpers/functions/types";
import { CollapsedFields } from "../../../components/GeneralUI/CollapsedFields/CollapsedFields";
import {
  GingerTeaCampaignData,
  HandleCampaignChange,
  HandleChangeValue,
} from "../../types";
import { GingerTeaManualClasses } from "./GingerTea/GingerTeaManualClasses";
import { gingerTeaSelectableSettings } from "./constants";
import { InfoRow } from "../../../ui/layout";
import { CampaignNumberic } from "../CampaignNumberic";

export const ObjectDetectionCollapsedFields: FC<{
  handleChange: HandleCampaignChange;
  objectDetector: CampaignObjectDetectorEnum;
  setObjectDetector: VoidFunc<CampaignObjectDetectorEnum>;
  campaign: CampaignBody;
  isModal?: boolean;
}> = ({
  campaign,
  handleChange,
  objectDetector,
  setObjectDetector,
  isModal,
}) => {
  const [gingerTeaProps, setGingerTeaProps] =
    useState<GingerTeaCampaignData>(campaign);

  useEffect(() => {
    if (objectDetector !== "ginger_tea") {
      handleChange("objectDetector", false)("ginger_tea");
      setObjectDetector("ginger_tea");
    }
  }, [objectDetector]);

  function ObjectDetectionSelect(
    propertyTitle: keyof typeof gingerTeaSelectableSettings,
    customLabel?: string,
  ) {
    return (
      <NamedSelect
        title={
          customLabel ??
          propertyTitle
            .split(/(?=[A-Z])/)
            .slice(2)
            .join(" ")
        }
        onChange={(target) => {
          const selectedValue = target.value as HandleChangeValue;
          handleChange(propertyTitle, false)(selectedValue);
          setGingerTeaProps((gingerTeaProps) => ({
            ...gingerTeaProps,
            [propertyTitle]: selectedValue,
          }));
        }}
        value={gingerTeaProps[propertyTitle]}
        options={gingerTeaSelectableSettings[propertyTitle]}
        styleVariant={isModal ? "slideOver" : "newPage"}
      />
    );
  }

  return (
    <CollapsedFields
      title="Object Detection"
      active={!!campaign?.useObjectDetection}
      resetFields={() => handleChange("useObjectDetection", false)(false)}
      activateFields={() => handleChange("useObjectDetection", false)(true)}
      customGroupStyles={isModal ? undefined : ""}
    >
      {campaign.objectDetector && campaign.objectDetector !== "ginger_tea" && (
        <InfoRow infoText="The previously used detection approach is obsolete. Ginger tea will be set by default." />
      )}

      <CampaignNumberic
        campaignKey="gingerTeaMaximumObjects"
        campaign={campaign}
        handleChange={handleChange}
      />

      {ObjectDetectionSelect("gingerTeaRelevantObjectClasses")}
      {/*{gingerTeaProps["gingerTeaRelevantObjectClasses"] ===*/}
      {/*  "category_tree" &&*/}
      {/*  ObjectDetectionSelect("gingerTeaCategoryTree")}*/}
      {/*//TODO - enable in scope of 37687 and implement children*/}
      {gingerTeaProps.gingerTeaRelevantObjectClasses === "manual" && (
        <GingerTeaManualClasses
          isModal={isModal}
          gingerTeaManualClasses={gingerTeaProps.gingerTeaManualClasses}
          handleChange={handleChange}
          setGingerTeaProps={setGingerTeaProps}
        />
      )}
    </CollapsedFields>
  );
};
